import React from 'react';
import {
    List,
    Datagrid,
    TextField,
    ShowButton,
    EditButton,
    TextInput,
    ReferenceField,
    TopToolbar,
    CreateButton,
    FilterButton,
    ExportButton
} from 'react-admin';

const socialFilters = [
    <TextInput label="Id" source="id" name="Id" />,
    <TextInput label="Platform" source="platform" name="platform" />,
];

const ListActions = () => {
    return(
        <TopToolbar>
            <CreateButton />
            <FilterButton />
            <ExportButton />
        </TopToolbar>
    );
}

export const AdminSocialList = () => {
    return(
        <List
            actions={ <ListActions /> }
            filters={ socialFilters }
        >
            <Datagrid bulkActionButtons={ false } >
                <TextField source="id" />
                <TextField source="platform" sx={ { textTransform: 'capitalize' } } />
                <ReferenceField
                    label="Company"
                    source="company"
                    reference="companies"
                    link="edit">
                    <TextField source="name" />
                </ReferenceField>
                <ReferenceField
                    label="Contact"
                    source="contact"
                    reference="contacts"
                    link="show">
                    <TextField source="name" />
                </ReferenceField>
                <>
                    <ShowButton />
                    <EditButton />
                </>
            </Datagrid>
        </List>
    );
}